import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import MantMovimientoCaja from "./components/MantMovimientoCaja";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import List from "../../global/content/List";
import AperturarCajaModal from "../../global/modals/AperturarCajaModal";
import MovimientosCajaModal from "../../global/modals/MovimientosCajaModal";
import CerrarCajaModal from "../../global/modals/CerrarCajaModal";
const MySwal = withReactContent(Swal);

const PageMovimientoCaja = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [page, setPage] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [pages, setPages] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [limit, setLimit] = useState(CONFIGURACIONES.INIT.LIMIT_PAGE);
    const [param, setParam] = useState(CONFIGURACIONES.INIT.STRING);
    const [dataList, setDataList] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [endPointShow, setEndPointShow] = useState(CONFIGURACIONES.INIT.STRING);
    const [endPointUpdate, setEndPointUpdate] = useState(CONFIGURACIONES.INIT.STRING);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [initDataApertura, setInitDataApertura] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataCierre, setInitDataCierre] = useState(CONFIGURACIONES.INIT.NULL);

    const [dataResumen, setDataResumen] = useState(CONFIGURACIONES.INIT.NULL);

    const [showApertura, setShowApertura] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showCerrarCaja, setShowCerrarCaja] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showMovimientoCaja, setShowMovimientoCaja] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [isLoadedInit, setIsLoadedInit] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
   
    const deleteAgency = async (param) => { 
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)) { return; }
       
        let endPointDelete = `${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/${param.id}`
        // console.log('endpoint', endPointDelete); 
        await Functions().deleteElementWithInput(endPointDelete, CONFIGURACIONES.MESSAGES.SUCCESS_DELETE_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.MOVIMIENTOS_CAJA} <strong>${param.conceptoPagoNombre}</strong>, forma de pago: <strong>${param.metodoPagoNombre}</strong> y monto: <strong>${param.monto}</strong> en <strong>${param.moneda}</strong>`,  getUser(), loadData, {})
    };

    const fnAperturarCaja = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        setShowApertura(CONFIGURACIONES.INIT.STATUS_TRUE);
    };
   
    const fnCloseApertura = (param) => {
        if (param !== CONFIGURACIONES.INIT.FLAG_CLOSE) { initData(); }
        setShowApertura(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveApertura = async (data) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/aperturar`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), fnCloseApertura, data);
  
    };

    const fnCerrarCaja = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        calcularCierreCaja();
        setShowCerrarCaja(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnCloseCerrarCaja = (param) => {
        if (param !== CONFIGURACIONES.INIT.FLAG_CLOSE) { initData(); loadData(); }
        setShowCerrarCaja(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveCerrarCaja = async (data) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { return; }
      
     
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/cerrar-caja/${initDataApertura.cajaActiva.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), fnCloseCerrarCaja, data);
    };

    const fnCrearMovimientoCaja = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        setShowMovimientoCaja(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnCloseCrearMovimientoCaja = (param) => {
        if (param !== CONFIGURACIONES.INIT.FLAG_CLOSE) { initData(); }
        setShowMovimientoCaja(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveCrearMovimientoCaja = async (data) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/guardar`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), fnCloseCrearMovimientoCaja, data);
  
    };

    const loadData = () => {
        setDataList(CONFIGURACIONES.INIT.ARRAY);
        setDataResumen(CONFIGURACIONES.INIT.NULL);
        setPages(CONFIGURACIONES.INIT.CURRENT_PAGE);
        
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { return; }
        let usuarioRegistro = getUser().user;
        let cajaId = initDataApertura.cajaActiva.id;

        Http().get(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}?param=${param}&page=${page}&limit=${limit}&usuarioRegistro=${usuarioRegistro}&cajaId=${cajaId}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataList(rpta.data.list);
                setDataResumen(rpta.data.resumen);
                setPages(rpta.pagination.pages);
            }
        });
    };

    const initData = () => {
        setInitDataApertura(CONFIGURACIONES.INIT.NULL);
        setIsLoadedInit(CONFIGURACIONES.INIT.STATUS_FALSE);
        let data = {
            body: {
                'usuarioRegistro': getUser().user,
            }
        }
        Http().post(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/util/init`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setInitDataApertura(rpta.data);
                setIsLoadedInit(CONFIGURACIONES.INIT.STATUS_TRUE);
            }
        });
    }

    const calcularCierreCaja = () => {
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { return; }
      
        setInitDataCierre(CONFIGURACIONES.INIT.NULL);
        let data = {
            body: {
                'usuarioRegistro': getUser().user,
            }
        }
        Http().post(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/calcular-cierre/${initDataApertura.cajaActiva.id}`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setInitDataCierre(rpta.data);
            }
        });
    }

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const fnShowAperturarCaja = () => {
        let showApertura = CONFIGURACIONES.INIT.STATUS_FALSE; 
        if (initDataApertura && initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) {
            showApertura = CONFIGURACIONES.INIT.STATUS_TRUE;
        }  
        return searchPermissions(CONFIGURACIONES.ACTIONS.CREAR) && showApertura;
    };
    
    const fnShowPrint = () => {
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { return false; }
       
        return true;
    };

    const fnShowCrearMovimiento = () => {
        let flag = true;
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { flag= false; }
       
        return searchPermissions(CONFIGURACIONES.ACTIONS.CREAR) && flag;
    };

    const fnShowCerrarCaja = () => {
        let flag = true;
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { flag= false; }
        return searchPermissions(CONFIGURACIONES.ACTIONS.CREAR) && flag;
    };

    const fnPrint = () => {
        if (!initDataApertura || initDataApertura.cajaActiva === CONFIGURACIONES.INIT.NULL) { return false; } 
        Http().get(`${CONFIGURACIONES.ENDPOINTS.MOVIMIENTOS_CAJA}/descargar-cierre/${initDataApertura.cajaActiva.id}`).then(async (rpta) => { 
            if (rpta.ok) {
                const pdfBlob = await rpta.blob(); 
                const blobUrl = URL.createObjectURL(pdfBlob);
                window.open(blobUrl, '_blank');
            }
        });
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar


    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        let search = localStorage.getItem('search');
        console.log('search', search);
        
        if (!search) {
            showSpinnerLoader();
        }
        localStorage.removeItem('search');
        // loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        } else {
            initData();
            // loadData();
        }
    }, [location.pathname])
    
    useEffect(() => {
        if (isLoadedInit) {loadData();}
    }, [isLoadedInit, page, param, limit]);

    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (<div className="col-md-12 col-xs-12">
                        <div className="card">
                            <div className="card-body">
                                <List icon={iconActive} title={'Movimientos de Caja'} headers={CONFIGURACIONES.TABLES.HEADERS.MOVIMIENTOS_CAJA} data={dataList} fnDelete={deleteAgency} setPage={setPage} pages={pages} page={page} 
                                    setParam={setParam} entityPagination={'det_mov_caja'} setLimit={setLimit} showEdit={CONFIGURACIONES.INIT.STATUS_FALSE} showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} showApertura={fnShowAperturarCaja()} showCrearMovimiento={fnShowCrearMovimiento()} showCerrar={fnShowCerrarCaja()} showPrint={fnShowPrint()}
                                    fnAperturarCaja={fnAperturarCaja} fnCerrarCaja={fnCerrarCaja} fnCreateMovimiento={fnCrearMovimientoCaja} fnPrint={fnPrint}
                                    />

                                <div className="row d-flex justify-content-center mt-5">
                                    <div className="col-xs-12 col-md-3">
                                        <table className="table table-bordered">
                                            <thead className="table-success">
                                                <tr>
                                                    <th className="text-center text-bold" colSpan={3}>Resumen</th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center text-bold"></th>
                                                    <th className="text-center text-bold">S/</th>
                                                    <th className="text-center text-bold">$</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataResumen && dataResumen.detalles.length > 0 ?(
                                                    dataResumen.detalles.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center text-bold">{item.nombre}</td>
                                                            <td className="text-right">{item.monto_soles}</td>
                                                            <td className="text-right">{item.monto_dolares}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" className="text-center text-muted">
                                                            <span className="text-danger">No se encontraron resultados</span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot className="table-info">
                                                <tr>
                                                    <td className="text-center text-bold">EFECTIVO NETO</td>
                                                    <td className="text-right text-bold">{(dataResumen && dataResumen.saldos.monto_soles) || '-'}</td>
                                                    <td className="text-right text-bold">{(dataResumen && dataResumen.saldos.monto_dolares || '-')}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}

                    {!isRenderList && (
                        <div className="col-lg-8 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantMovimientoCaja mant={'Caja'} idEdit={idRef} MySwal={MySwal} idRef={idRef} setIdRef={setIdRef} endPointShow={endPointShow} setEndPointUpdate={setEndPointUpdate} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} seriesAsignadas={seriesAsignadas}
                                        showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <AperturarCajaModal show={showApertura} onClose={fnCloseApertura} onSave={fnSaveApertura} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} title={"Aperturar Caja"} initDataApertura={initDataApertura} />
                    <MovimientosCajaModal show={showMovimientoCaja} onClose={fnCloseCrearMovimientoCaja} onSave={fnSaveCrearMovimientoCaja} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} title={"Crear Movimiento de Caja"} initDataApertura={initDataApertura} />
                    <CerrarCajaModal show={showCerrarCaja} onClose={fnCloseCerrarCaja} onSave={fnSaveCerrarCaja} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} title={"Cerrar Caja"} initDataApertura={initDataApertura} initDataCierre={initDataCierre} />
                      
                </div>
            </div>
        </div>
    )
}

export default PageMovimientoCaja;